import { yupResolver } from '@hookform/resolvers/yup';
import type { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { ButtonVariant, FormInput, Button } from '@catalyze/ui';
import { CardContainer } from 'features/SignUp/components/CardContainer';
import { Spacer } from 'features/SignUp/components/forms/DocusSignForm/styled';
import { FormTitle } from 'features/SignUp/components/FormTitle';
import { ProgressBar } from 'features/SignUp/components/ProgressBar';
import { STEP_COUNT } from 'features/SignUp/types/signUpForm';
import { createPasswordSchema } from 'schemas/createPassword';

import { StyledForm } from './styled';

export interface ICreatePasswordForm {
    password: string;
    confirmPassword: string;
}

interface IChangePasswordFormProps {
    onSubmit: (data: ICreatePasswordForm) => void;
}

export const ChangePasswordForm: FC<IChangePasswordFormProps> = ({
    onSubmit,
}) => {
    const formMethods = useForm<
        Record<keyof typeof createPasswordSchema.fields, string>
    >({
        resolver: yupResolver(createPasswordSchema),
    });

    const { handleSubmit } = formMethods;

    return (
        <CardContainer>
            <ProgressBar progress={(6 / STEP_COUNT) * 100} />
            <FormTitle
                title="Create a password"
                subtitle="Your password should have at least 8 characters."
            />
            <FormProvider {...formMethods}>
                <StyledForm onSubmit={handleSubmit(onSubmit)}>
                    <FormInput id="password" type="password" label="Password" />
                    <FormInput
                        id="confirmPassword"
                        type="password"
                        label="Confirm Password"
                    />
                    <Spacer />
                    <Button type="submit" variant={ButtonVariant.PRIMARY}>
                        Create
                    </Button>
                </StyledForm>
            </FormProvider>
        </CardContainer>
    );
};
